import CheckBoxesField from './CheckBoxesField';

export default CheckBoxesField;
